export default {
  meta: {
    title: '月报详情',
    url: '/abside/monthdetail', // 埋点字段，上报归属的模块
    urlName: 'ab侧-月报详情', // 埋点字段，上报归属的模块
    logincallback: '/abside',
  }
};
